<nav class="side-menu" [@slideInLeft]>
  <div class="content">
    <ng-content></ng-content>
  </div>
</nav>
<div class="backdrop" [@fade] (click)="close()"></div>
